/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import { isEmpty } from 'lodash';

import FreePlanView from './FreePlanView';
import PurchasablePlanView from './PurchasablePlanView';
import PurchasedPlanView from './PurchasedPlanView';
import IndividualPlanOrgUpsellView from './IndividualPlanOrgUpsellView';

import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';

import LoadingIndicator from 'components/LoadingIndicator';
import ErrorReporter from 'app/components/ErrorReporter';

import INDIVIDUAL_PLAN_QUERY from '../queries/IndividualPlanViewQuery.gql';
import type { IndividualPlanView } from '../queries/__generated__/IndividualPlanView';

type Props = {
  data: ReactApolloData<IndividualPlanView>,
};

class IndividualPlanContainer extends React.Component<Props> {
  render() {
    const { data } = this.props;

    if (data.loading) {
      return <LoadingIndicator />;
    }

    if (data.error) {
      return <ErrorReporter error={data.error} />;
    }

    if (!data.me) {
      return <ErrorReporter error="Can't find plan for current user." />;
    }

    const { individualPlans, organizations } = data.me;

    const freeIndividualPlan = individualPlans.find(
      plan => plan.__typename === 'FreeIndividualPlan'
    );
    const purchasedIndividualPlan = individualPlans.find(
      plan => plan.__typename === 'PurchasedIndividualPlan'
    );
    const purchasableIndividualPlan = individualPlans.find(
      plan => plan.__typename === 'PurchasableIndividualPlan'
    );

    if (freeIndividualPlan && freeIndividualPlan.__typename !== 'FreeIndividualPlan') {
      return <ErrorReporter error="Error Loading FreePlan" />;
    }

    const hasFreePlan = isEmpty(purchasedIndividualPlan);

    const inPaidOrg = organizations.some(org => org && org.paid);

    if (!organizations) {
      return <ErrorReporter error="Error Loading User Organization Data" />;
    }

    return (
      <div>
        <Row>
          <Heading level="2">Remind Plans</Heading>
          <Text color="eclipse" size="medium">
            Get access to premium features to improve your Remind experience
          </Text>
        </Row>
        <Row>
          <FreePlanView hasFreePlan={hasFreePlan} freeIndividualPlan={freeIndividualPlan} />
        </Row>
        <Row>
          {purchasableIndividualPlan && (
            <PurchasablePlanView inPaidOrg={inPaidOrg} plan={purchasableIndividualPlan} />
          )}
          {purchasedIndividualPlan && (
            <PurchasedPlanView inPaidOrg={inPaidOrg} plan={purchasedIndividualPlan} />
          )}
        </Row>
        <Row>
          {organizations.length > 0 && <IndividualPlanOrgUpsellView inPaidOrg={inPaidOrg} />}
        </Row>
      </div>
    );
  }
}

const withData = graphql(INDIVIDUAL_PLAN_QUERY);

export { IndividualPlanContainer };
export default withData(IndividualPlanContainer);
